import type {
    DropdownItemProps,
    ShorthandCollection,
    ShorthandValue,
} from '@archipro-design/aria';
import { generateURL, parseURL } from '@archipro-website/top-navigation';
import { Link, useLocation } from '@remix-run/react';
import type { ElasticSearchCategories } from '../type/api';
import { useSearchSorts } from './use-search-sorts';

interface Options {
    category?: ElasticSearchCategories;
}

export interface SearchSortOptionResult {
    items: ShorthandCollection<DropdownItemProps>;
    value?: ShorthandValue<DropdownItemProps>;
    defaultSortName: string | undefined;
}

const useSearchSortOptions = ({
    category,
}: Options): SearchSortOptionResult => {
    const { sortOptions, defaultSortName } = useSearchSorts({ category });
    const location = useLocation();
    const { basePath, params } = parseURL(location.pathname + location.search);
    const items: ShorthandCollection<DropdownItemProps> = [];
    let selectIndex = -1;
    sortOptions.forEach((sortOption, index) => {
        if (sortOption.selected) selectIndex = index;
        delete params['page'];
        const newLink = generateURL(basePath, {
            ...params,
            sort: sortOption.value ? [sortOption.value] : [],
        });
        items.push({
            as: Link,
            to: newLink,
            preventScrollReset: true,
            header: sortOption.header,
        });
    });
    const value = selectIndex === -1 ? undefined : items[selectIndex];

    return { items, value, defaultSortName };
};

export { useSearchSortOptions };
